import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function OutsideClickHandler(props) {
  const { children, callback, forButton } = props;

  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, callback, forButton);

  return <div ref={wrapperRef}>{children}</div>;
}

OutsideClickHandler.propTypes = {
  children: PropTypes.any,
  callback: PropTypes.func,
  forButton: PropTypes.string
};

function useOutsideAlerter(ref, callback, forButton) {
  function handleClickOutside(event) {
    const target = event.target;

    if (ref.current && !ref.current.contains(target) && !isIgnoredItem(target)) {
      callback();
    }

    function isIgnoredItem(t) {
      const parent = t.parentNode;

      return forButton === t.id || (parent && isIgnoredItem(parent));
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
}

